import dayjs from "dayjs";

export const packsValidator = (fields) => {
  const errors = {};

  if (!fields.title || fields.title.trim() === "") {
    errors.title = "El título no puede estar vacío";
  }

  if (!fields.postal_code || fields.postal_code.trim() === "") {
    errors.postal_code = "El código postal no puede estar vacío";
  }

  if (
    typeof fields.internet_data.id === "undefined" &&
    fields.internet_data.new_price > 0
  ) {
    errors.internet_data =
      "El precio no puede ser mayor a 0 si no hay un plan de internet seleccionado";
  }

  if (
    typeof fields.television_data.id === "undefined" &&
    fields.television_data.new_price > 0
  ) {
    errors.television_data =
      "El precio no puede ser mayor a 0 si no hay un plan de televisión seleccionado";
  }

  if (fields.phone_data.length > 0) {
    errors.phone_data = [];
    fields.phone_data.forEach((phone) => {
      if (typeof phone.id === "undefined" && phone.new_price > 0) {
        errors.phone_data.push(
          "El precio no puede ser mayor a 0 si no hay un plan de televisión seleccionado"
        );
      } else {
        errors.phone_data.push(null);
      }
    });
  }

  if (
    typeof fields.internet_data.id === "undefined" &&
    typeof fields.television_data.id === "undefined" &&
    fields.phone_data.length < 1
  ) {
    errors.discount = "Al menos un producto debe ser seleccionado.";
  }

  if (!fields.start_day || !fields.end_day) {
    errors.valid_range = "El periodo de validez es requerido";
  }

  if (fields.start_day && fields.end_day) {
    const today = dayjs();
    const formatted_start_day = dayjs(fields.start_day, "DD/MM/YYYY");
    const formatted_end_day = dayjs(fields.end_day, "DD/MM/YYYY");

    if (
      formatted_start_day.isBefore(today, "day") &&
      formatted_end_day.isBefore(today, "day")
    ) {
      errors.valid_rangeW = "Las fechas introducidas ya han caducado";
    } else if (formatted_start_day.isBefore(today, "day")) {
      errors.valid_rangeW = "La fecha de inicio ya ha caducado";
    } else if (formatted_end_day.isBefore(today, "day")) {
      errors.valid_rangeW = "La fecha de finalización ya ha caducado";
    }
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/views/Configurator/utils/packsValidator.js